class jfSystemMonitor {

    constructor($timeout, $scope, XRayUIState, MonitorDao, DatabaseSyncDao, JFrogEventBus, JFrogGridFactory, uiGridConstants,
                XRayUIPermissions) {
        this.MonitorDao = MonitorDao;
        this.DatabaseSyncDao = DatabaseSyncDao;
        this.XRayUIPermissions = XRayUIPermissions;
        this.JFrogGridFactory = JFrogGridFactory;
        this.XRayUIState = XRayUIState;
        this.uiGridConstants = uiGridConstants;
        let EVENTS = JFrogEventBus.getEventsDefinition();
        let removeListener = JFrogEventBus.register(EVENTS.MONITORING_DATA_UPDATED, (msg) => this.wsDataRecieved(msg));

        this.$timeout = $timeout;

        this.$timeout(() => {
            if (this.XRayUIPermissions.isAdmin() && !this.XRayUIState.getState('isSaas')) {
                this.getUpdateData();
            }
        }, 500)

        this.$scope = $scope;
        this._createGrid();
        $scope.$on('$destroy', () => {
            removeListener();
        });


    }

    getUpdateData(showSpinner = true, callListener = true) {
        //console.log('getting system issues');
        this.$timeout(() => {
            if (!this.XRayUIState.getState('isSaas')) {
                console.log("THIS!!2");
                this.MonitorDao.getIssues({$no_spinner: true}).$promise.then((data) => {
                    this.gridData = data.problems;

                    this.issuesSum = {
                        errors: _.filter(data.problems, (n) => {
                            return n.severity == "error"
                        }).length,
                        warnings: _.filter(data.problems, (n) => {
                            return n.severity == "warning"
                        }).length
                    }
                    if (this.gridData) {
                        this.showMonitoring = true;
                    } else {
                        this.showMonitoring = false;
                    }
                    this.gridOptions.setGridData(this.gridData);

                    if (data.problems) {
                        if (data.problems.length < 1) {
                            this.noData = true;
                            this.severity_level = 'icon-xray-monitoring-ready';
                        } else {
                            this.noData = false;
                            this.severity_level = this._checkTopSeverity(this.gridData);

                        }

                    }

                });
            }

        }, 500)

    }


    _createGrid() {
        this.gridOptions = this.JFrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getColumns());
        /*
         .setButtons(this._getActions())
         */

        this.gridOptions.setGridData([]);

    }


    _getColumns() {
        return [


            {
                name: 'Severity',
                displayName: 'Severity',
                cellTemplate: ` <span class="severity-colorbar" ng-class="(row.entity.severity|| \'Unknown\').toLowerCase()">{{row.entity.severity | capitalizeFirst}}</span>`,
                field: 'severity',
                width: '13%'
            },
            {
                name: 'Problem',
                displayName: 'Problem',
                field: 'problem',
                width: '72%'
            },
            {
                name: 'Services',
                displayName: 'Services',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.services.join(', ') | capitalizeFirst }}</div>`,
                field: 'services',
                width: '15%'
            }
        ];
    }

    wsDataRecieved(msg) {
        this.wsMsg = msg.Data.problems;

        this.gridOptions.setGridData(this.wsMsg);

        this.issuesSum = {
            errors: _.filter(this.wsMsg, (n) => {
                return n.severity == "error"
            }).length,
            warnings: _.filter(this.wsMsg, (n) => {
                return n.severity == "warning"
            }).length
        }

        if (msg.Data.problems.length < 1) {
            this.noData = true;
            this.severity_level = 'icon-xray-monitoring-ready';
        } else {
            this.noData = false;
            this.severity_level = this._checkTopSeverity(this.wsMsg);
        }

        this.$scope.$apply();
    }


    _checkTopSeverity(obj) {

        let sev_arr = [];
        obj.forEach((el) => {


            sev_arr.push(el.severity);


        });

        if (sev_arr.indexOf('error') > -1) {

            return 'icon-xray-monitoring-error';
        } else if (sev_arr.indexOf('warning') > -1) {

            return 'icon-xray-monitoring-alert';
        } else {
            return 'normal';
        }

    }


}// class
export function jfSystemMonitor() {

    return {
        restrict: 'E',
        scope: {

            titleText: '@?',
            noIssueText: '@?'
        },
        templateUrl: 'directives/jf_system_monitor/jf_system_monitor.html',
        controller: jfSystemMonitor,
        controllerAs: 'jfSystemMonitor',
        bindToController: true
    };
}





// WEBPACK FOOTER //
// ./modules/xray/directives/jf_system_monitor/jf_system_monitor.js